/**
 * The thread's inline option lists (questions, scenarios): five rows first,
 * then "Show all N" expands into a fixed-height scrolling list that loads
 * further pages as the author nears its end.
 */

/** Rows shown before "Show all N". */
export const PREVIEW_ROWS = 5;
/** Page size of the expanded list. */
export const FULL_PAGE_SIZE = 100;
/** The expanded list's height until it has measured its rows, in px. */
export const FALLBACK_LIST_HEIGHT = 320;
/** How close to the end of the expanded list a scroll loads the next page, in px. */
export const LOAD_MORE_THRESHOLD_PX = 120;
